// extracted by mini-css-extract-plugin
module.exports = {"notes":"LabNotebookTemplatesTable_notes__1hkZ2"};